import { Panel, PanelHeader, PanelHeaderBack } from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { memo } from 'react';
import { $prevActivePanel, setActivePanel } from 'src/entity/ActivePanel';
import cls from './PuzzleGamePannel.module.scss';

interface IPuzzleGamePannel {
  id:string
}

export const PuzzleGamePannel = memo(({ id }: IPuzzleGamePannel) => {
  const [
    onSetActivePanel,
    prevActivePanel
  ] = useUnit([
    setActivePanel,
    $prevActivePanel
  ]);

  const onBackButtonClick = () => {
    if (!prevActivePanel) return;

    onSetActivePanel(prevActivePanel);
  };

  return (
    <Panel id={id}>
      <PanelHeader
        visor={false}
        transparent
        separator={false}
        style={{ width: '0px' }}
        before={(
          <PanelHeaderBack
            onClick={onBackButtonClick}
          />
        )}
      />
      <iframe
        src='https://puzzle-2d.karusel-tv.ru/?theme=glavgeroi&v=6.8.476'
        title='Puzzle Game'
        className={cls.iframe}
      />
    </Panel>
  );
});
